import { FC } from 'react'
import { Rule } from '@wellesley/openapi'

type RuleRowProps = {
  rule: Rule
  ruleNumber: number
}

const RuleRow: FC<RuleRowProps> = ({ rule, ruleNumber }) => (
  <div className="flex gap-xxs">
    <span className="text-base font-semibold">{ruleNumber}.</span>
    <div className="flex flex-col gap-xxs">
      <h3 className="text-base font-semibold" data-testid="rule-text">
        {rule.text}
      </h3>
      <p className="text-base">{rule.hint}</p>
    </div>
  </div>
)

export default RuleRow
